module.exports = __webpack_public_path__ + "img/menu.babbfb28.svg";